<template>
  <div>
    <v-card class="overview-risk-card light-card" id="overviewRisk">
      <overview-risk-actions @onCapture="handleTreeMapCapture" />
      <zoomable-treemap ref="treeMapRef"
      @rectangleColors="setIndicatorMinAndMaxColor"
      />
      <overview-risk-indicator
       :indicatorColor="indicatorMinMax"
      />
    </v-card>
  </div>
</template>

<script>
import OverviewRiskActions from './OverviewRiskActions'
import OverviewRiskIndicator from './OverviewRiskIndicator'
import ZoomableTreemap from './ZoomableTreemap'
export default {
  name: 'OverviewRisk',
  components: {
    OverviewRiskActions,
    OverviewRiskIndicator,
    ZoomableTreemap
  },
  data () {
    return {
      indicatorMinMax: []
    }
  },
  methods: {
    handleTreeMapCapture () {
      this.$refs.treeMapRef.handleCapture()
    },
    setIndicatorMinAndMaxColor (colors) {
      this.indicatorMinMax = colors
    }
  }
}
</script>

<style lang="scss">
  .light-card.overview-risk-card {
    border: none !important;
    position: relative;
    padding: 0 0px;
  }
</style>
